export const GENERIC_PASS_MSG = 'You saved with coupon'
export const HEADING_TEXT = 'Apply coupon'
export const GENERIC_COUPON_FAIL_MSG = 'Please try a valid coupon'
export const GENERIC_GV_FAIL_MSG = 'Please try a valid gift card'
export const SOMETHING_WENT_WRONG_ERROR = 'Something went wrong. Please try again'
export const CANT_APPLY_COUPON_ON_GV = 'You cannot apply a coupon code when a gift card has already been used'
export const COUPON_NOT_ENTERED = `You haven't entered a coupon code`

export const fareCardMap = {
    STANDARD_FARE: '',
    AMEND_INSURANCE: 'AMEND',
    DOM_CANCELATION_INSURANCE: 'CANCEL'
}

export const regexObj = {
    GV_NUMBER: /^[0-9]{1,16}$/,
    PIN: /^[0-9]{0,6}$/
}
